function isAdaChatFrameActive(chatFrame) {
  if (!chatFrame) return false;

  const computed = window.getComputedStyle(chatFrame);
  const { width, height } = chatFrame.getBoundingClientRect();

  return (
    width > 0 &&
    height > 0 &&
    computed.display !== 'none' &&
    computed.visibility !== 'hidden' &&
    Number(computed.opacity) > 0
  );
}

function syncAdaChatEntryState() {
  const adaEntry = document.querySelector('#ada-entry');

  if (!adaEntry) return;

  const chatFrame = adaEntry.querySelector('.ada-chat-frame');
  const isActive = isAdaChatFrameActive(chatFrame);

  adaEntry.classList.toggle('ada-chat-active', isActive);
}

export default function initAdaChatEntry() {
  syncAdaChatEntryState();

  const observer = new MutationObserver(syncAdaChatEntryState);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
  });
}
